<template>
    <div>
        <div class="form-group row d-flex align-items-center">
            <div class="col-lg-12">
                <p
                    v-if="isContainerOpen === false"
                    @click="openAdditionalCommentsContainer()"
                    class="c-pointer a-primary"
                >Additional comments</p>
                <p
                    v-if="isContainerOpen === true || additionalCommentValue !== null && additionalCommentValue !== undefined"
                    @click="removeAdditionalComments()"
                    class="c-pointer a-danger"
                >
                    Remove additional comments
                </p>
            </div>
        </div>
        <div class="form-group row d-flex align-items-center"
             v-if="isContainerOpen === true || additionalCommentValue !== null && additionalCommentValue !== undefined">
            <div class="col-lg-12">
                <textarea
                    v-model="additionalCommentValue"
                    class="form-control"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'value',
        ],
        data() {
            return {
                additionalCommentValue: this.value,
                isContainerOpen: false,
            }
        },
        watch: {
            additionalCommentValue(val) {
                this.$emit('input', val);
            },
        },
        methods: {
            getContainerClasses(field) {
                return this.$parent.getContainerClasses(field);
            },
            openAdditionalCommentsContainer() {
                this.isContainerOpen = true;
            },
            removeAdditionalComments() {
                this.isContainerOpen = false;
                this.additionalCommentValue = null;
            },
        },
    }
</script>